<template>
  <div class="home contenido terminos">
    <div class="container">
    <HelloWorld 
        msg="Términos y Condiciones"
        :imagen="imagen"
     />
     <Titulo titulo="Términos y Condiciones" />
     <div class="row m-0 mb-5 justify-content-center">
        <div class="col-10 my-5">
            <ol>
                <li>Estos productos son ofrecidos por RMZ ASESORES o por Ana Maria Carabes Gonzalez, Roberto Ramirez de Leon, Roberto  Ramirez Montaño (intermediarios). Estos seguros son operados y propiedad de las aseguradoras PLAN SEGURO SA de CV, AXA Seguros S.A de CV., Chubb Seguros México, S.A.de CV  (“Aseguradoras”) para Asegurados de los intermediarios. Las Aseguradoras son responsables frente a los Asegurados del cabal cumplimiento de los Términos y Condiciones del Seguro, razón por la cual, RMZ ASESORES, Ana Maria Carabes Gonzalez, Roberto Ramirez de Leon, Roberto  Ramirez Montaño, no asumen ninguna responsabilidad sobre el mismo. Los Términos, Condiciones, Restricciones y Exclusiones del Seguro se establecen con claridad y precisión en el Contrato y en la Póliza del Seguro correspondiente que el Asegurado recibirá por parte de Las Aseguradoras. La Póliza se rige con base en las Condiciones Generales de la misma.</li>
                <li><strong>Seguro de Gastos Médicos Mayores</strong> 
                    <p>La aseguradora pagara aquellos gastos que efectúe el Asegurado por servicios médicos requeridos para la atención de cualquier Accidente y/o Enfermedad cubierta que, por indicación de un Médico autorizado legalmente para el ejercicio de su profesión, sean necesarios para el tratamiento del Asegurado. Si durante la vigencia de la Póliza, como consecuencia de un Accidente y/o Enfermedad cubierta e iniciada, el Asegurado incurriera en cualquiera de los Gastos Médicos Cubiertos, Plan Seguro cubrirá el costo de los mismos, hasta por la cantidad máxima asegurada en cada Cobertura o la Suma Asegurada contratada según corresponda, ajustándolo a los límites establecidos en la Carátula de la Póliza, Endosos y Condiciones Generales.</p>
                    <p>Para revisar Términos y Condiciones visita: <a href="/pdf/CondicionesGeneralesGMMEscencial.pdf">Términos y Condiciones</a></p>
                </li>
                <li>Para saber cómo obtenemos, protegemos y utilizamos tu información personal, visita la <router-link to="/aviso-de-privacidad">declaración de privacidad de RMZ Asesores</router-link>.</li>
                <li>Las comunicaciones vía correo electrónico de RMZ Asesores (Intermediarios) se basan en el manejo de Cookies y/o Web Beacons que permiten que RMZ Asesores (intermediarios) recabe automáticamente datos personales. Al recibir este correo y consultar el contenido del mismo, consientes que RMZ Asesores (intermediarios) recabe y trate tus datos personales. El uso de estas tecnologías es necesario por motivos de operación, técnicos y de seguridad. Para más información favor de consultar los Términos y Condiciones, haciendo clic <router-link to="/cookies">aquí</router-link>.</li>
            </ol>
            <p class="text-center">{{ $store.getters.anio }} Derechos Reservados © RMZ Asesores (Intermediarios).</p>
        </div>
     </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/fondoAzul.svg'
import Titulo from '@/components/Titulo.vue'
export default {
  name: 'Terminos',
  data() {
      return {
          imagen: Imagen,
      }
  },
  components: {
    HelloWorld,
    Titulo,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      ocultaFooter: function(){
          this.$store.commit('ocultaFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.ocultaFooter();
      this.$store.commit('mideMenos', true);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
.my-5 {
    margin-bottom: 150px !important;
}
a {
    color: #1900FF;
    font-weight: 600;
}
ol {
    list-style: none;
    counter-reset: section;
}
ol li {
    counter-increment: section;
}
ol li:before {
    content: counters(section, ".")".";
}
ol li ul li:before {
    content:" ";
}
ol li ul li {
    counter-increment: none;
}
ol li {
    padding: 10px 10px 10px 45px;
    font-size: 18px;
    counter-increment: item;
    margin-bottom: 5px;
}
ol li:before {
    margin-right: 10px;
    margin-left: -50px;
    content: counter(item)'.';
    width: 1.2em;
    text-align: left;
    font-size: 30px;
    font-weight: 800;
}
ol ul li {
    padding: 0 0 0 10px;
    font-size: 18px;
    margin-bottom: 0;
}
ol ul li:before {
    margin-right: -10px;
    margin-left: 10px;
    content: counter(item)'.';
    width: 1.2em;
    text-align: left;
    font-size: 30px;
    font-weight: 800;
}
@media only screen and (max-width: 768px){
    ol {
        padding: 0;
    }
    li {
        padding: 10px 0 10px 10px;
    }
}
</style>
<style>
.contGeneral {
   /*height: 450px;*/
}
</style>
